var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"header-img col-xs-12"},[_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.src}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }